import React from 'react';
import {Link} from 'react-router-dom';
import editLogo from '../../../../assets/images/edit.png';
import SMCHighlighter from '../../../Simple/SMCHighlighter';

function EditObjectCell({
    value,
    textToHighlight,
    showEditIcon = true
}) {
    if (value) {
        let ret;
        if (showEditIcon === true)
            ret = <Link to={`?id=${value}`}>
                <img align="absmiddle" alt="" src={editLogo}/>
                <SMCHighlighter highlight={textToHighlight} text={value}/>
            </Link>

        else
            ret = <Link to={`?id=${value}`}> <SMCHighlighter highlight={textToHighlight} text={value}/></Link>
        return (
            ret
        )
    }
    return null;
}

export default EditObjectCell;